import React, {useEffect, useState} from "react";
import DatePickerComponent from "../Shared/Inputs/DatePickerComponent";
import {Col} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import {BillingActions} from "../../Store/Billing/Slice";
import {Customer} from "../../Models/Customer";
import BillingTableComponent from "./BillingTableComponent";
import {FormGroup, Label, Input} from "reactstrap";

const BillingComponent = () => {

  const {CompanyReducer: {branch_selected, company_selected}} = useSelector((state: RootState) => state);

  const [customerSelected,setCustomerSelected] = useState(''); //Company or branch selected

  const [date, setDate] = useState<Date | null>();
  const [all, setAll] = useState<Boolean>(false);

  const dispatch = useDispatch();

  // set the company or branch selected from the store
  useEffect(()=>{
    const currentCustomer = (branch_selected as Customer) || (company_selected as Customer);
    setCustomerSelected(currentCustomer?._KEY || '');
  },[branch_selected,company_selected]);

  useEffect(() => {
    if (customerSelected) {
      dispatch(BillingActions.getBills({customer: customerSelected}));
    }
  }, [dispatch,customerSelected]);

  useEffect(() => {
    const params: any = {
      customer: customerSelected,
      all
    }

    if (!!date) {
      dispatch(BillingActions.getBills({
        ...params,
        payment_date: date
      }));
    } else {
      dispatch(BillingActions.getBills(params));
    }
  }, [customerSelected, date, all, dispatch])

  const handleChange = (date: Date | null) => {
    setDate(date);
  };

  return (
    <div  className="my-4">
      <div  className="container">
        <div className="d-flex justify-content-end row">
          {
            (company_selected as Customer)?._KEY === (branch_selected as Customer)?._KEY &&
            <Col className="mb-4" lg={2}>
              <FormGroup check inline>
                <Label check>
                  <Input type="checkbox" onChange={(e: any) => {
                    setAll(e.currentTarget.checked)
                  }} /> TODAS
                </Label>
              </FormGroup>
            </Col>
          }
          <Col className="mb-4" lg={4}>
            <DatePickerComponent value={date} onChange={(e: Date | null) => handleChange(e)}/>
          </Col>
        </div>
        <BillingTableComponent/>
      </div>
    </div>
  );
};

export default BillingComponent;
